import React from 'react';
import {
    translateResourceString
} from '../util/translationUtility';
import { formatAddress } from '../util/formatUtility';

class InvoiceSearch extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searchTerm: "",
            searchBoxHasFocus: false
        };
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.selectedAccountOrganizationOption !== this.props.selectedAccountOrganizationOption) {
            this.setState({ searchTerm: this.getDisplay(this.props.selectedAccountOrganizationOption) })
        }
    }


    //getKey = (option) => !!option.OrganizationId ? option.OrganizationId : option.AccountId;
    getKey = (accountOrganizationOption) => `${accountOrganizationOption.OrganizationId},${accountOrganizationOption.AccountId}`;

    getDisplay = (accountOrganizationOption) => {
        let display = accountOrganizationOption.Name;
        if (!accountOrganizationOption.AccountId) {
            display += "- ALL";
        } else {
            display += "- " + formatAddress(accountOrganizationOption.Address)
        }
        return display;
    }

    onAccountOrganizationOptionSelected = (option) => {
        this.setState({ searchTerm: "" })
        this.props.setSelectedAccountOrganization(option);
    }

    onAccountOrganizationOptionSelected = (option) => {
        this.props.setSelectedAccountOrganization(option);
    }

    onFocusChanged = (hasFocus) => {
        this.setState({
            searchBoxHasFocus: hasFocus,
            searchTerm: hasFocus ? "" : this.state.searchTerm
        });
    }

    render() {
        const {
            accountOrganizationOptions,
            selectedAccountOrganizationOption
        } = this.props;


        const {
            searchTerm,
            searchBoxHasFocus
        } = this.state;

        let filteredOptions = !searchTerm
            ? accountOrganizationOptions
            : accountOrganizationOptions.filter((option) => this.getDisplay(option).toLowerCase().includes(searchTerm.toLowerCase()));

        if (!!selectedAccountOrganizationOption && this.getDisplay(selectedAccountOrganizationOption) === searchTerm) {
            filteredOptions = []
        }

        const showAutocomplete = searchBoxHasFocus && filteredOptions.length > 0;

        return (
            <div className="invoice-payments--search">
                <div onClick={() => this.searchInput.focus()} style={{ position: "absolute", right: "1rem", top: ".8rem", zIndex: 2 }}>
                    <i className="fas fa-caret-down"></i>
                </div>
                <div className="input-container" style={{ position: "relative" }} onBlur={() => this.onFocusChanged(false)}>
                    <input className="form-control"
                        ref={(input) => { this.searchInput = input; }}
                        type="text" value={searchBoxHasFocus
                            ? searchTerm
                            : (selectedAccountOrganizationOption && this.getDisplay(selectedAccountOrganizationOption)) || searchTerm}
                        placeholder={translateResourceString("/MyAccountPage/InvoicePayments/DefaultSelectOptionText")}
                        onChange={(e) => this.setState({ searchTerm: e.target.value })}
                        onFocus={() => this.onFocusChanged(true)}
                    />
                    <div className="easy-autocomplete-container" style={{ width: "100%", top: "100%" }}>
                        <ul style={showAutocomplete ? { display: "block" } : {}}>
                            {filteredOptions.map((option) => {
                                return <li className="eac-item" key={this.getKey(option)} onClick={() => this.onAccountOrganizationOptionSelected(option)}>
                                    {this.getDisplay(option)}
                                </li>
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default InvoiceSearch;